/**
 * Created by Marcus Zhao on 07/2/2021.
 *  Description:
 * ------ maintenance history ------
 */
import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { businessConstants } from '../../../../../constants/business.constants';
import { ThreadViewActionTypes } from '../../../../../redux/actions/thread-view.actions';
import { SlideSheetService } from '../../../../../services/slide-sheet.service';
import { IAppState } from '@tamalelibs/redux/app.state';
import { SlideSheetActionTypes } from '../../../../slide-sheet/slide-sheet.model';
import { TamDashboardTileData } from '../../tam-dashboard-map-tile.config';
import { TamDashboardMapTileService } from '../../tam-dashboard-map-tile.service';
import { MapAction } from '../tam-dashboard-map.model';

@Component({
    selector: 'tam-dashboard-map-poi',
    templateUrl: './tam-dashboard-map-poi.component.html',
    styleUrls: ['./tam-dashboard-map-poi.component.scss'],
    standalone: false
})
export class TamDashboardMapPoiComponent implements OnInit {
    @Input() marker: TamDashboardTileData;
    @Input() id: string;
    @Input() isShowEventOnMap = false;
    showUIIndex = 0;
    contactAddress: string;
    duplicateAddress = [];

    constructor(
        private _slideSheetService: SlideSheetService,
        private _store: Store<IAppState>,
        private _tamDashboardMapTileService: TamDashboardMapTileService
    ) { }

    ngOnInit() {
        this._initUIByType(this.marker);
    }

    addStopToMapTrip() {
        this._tamDashboardMapTileService.feedbackSubject$.next(
            {
                type: MapAction.ADD_STOP,
                payload: this.marker,
                id: this.id
            }
        );
    }

    directToMapTrip() {
        this._tamDashboardMapTileService.feedbackSubject$.next(
            {
                type: MapAction.OPEN_TRIP,
                payload: this.marker,
                id: this.id
            }
        );
    }

    searchNearby() {
        let data;
        if (this.marker.entityType === businessConstants.addressType.duplicate) {
            data = this.marker.duplicateAddress[0].list[0];
        } else {
            data = this.marker;
        }
        this._tamDashboardMapTileService.feedbackSubject$.next(
            {
                type: MapAction.OPEN_NEARBY,
                payload: data,
                id: this.id
            }
        );
    }

    /**
     * open entity / contact slidesheet by id and type
     *
     * @memberof TamDashboardMapPoiComponent
     */
    showContactDetail(marker) {
        if (marker.entityType === 'Event') {
            this._store.dispatch({
                type: ThreadViewActionTypes.GET_THREAD_SIDESHEET,
                payload: marker.threadId
            });
            this._slideSheetService.slideSheetActionSubject$.next({
                type: SlideSheetActionTypes.THREAD_SIDESHEET,
                payload: marker.entityId
            });
        } else {
            if (marker && marker.entityId) {
                if (marker.entityType === businessConstants.addressType.contact) {
                    this._slideSheetService.slideSheetActionSubject$.next({
                        type: SlideSheetActionTypes.CONTACT_PANEL,
                        payload: marker.entityId
                    });
                } else {
                    this._slideSheetService.slideSheetActionSubject$.next({
                        type: SlideSheetActionTypes.ENTITY_PANEL,
                        payload: marker.entityId
                    });
                }
            }
        }
    }

    /**
     * open link to google map
     *
     * @memberof TamDashboardMapPoiComponent
     */
    viewOnGoogleMap() {
        const href = 'https://www.google.com/maps/place/' + this.marker.address + '/@' + this.marker.latitude + ',' + this.marker.longitude + ',15z';
        window.open(href);
    }

    private _getAddress() {
        if (this.marker.address) {
            this.contactAddress = this.marker.address;
        }
    }

    private _initUIByType(marker: TamDashboardTileData) {
        switch (this.marker.entityType) {
            case businessConstants.addressType.contact:
                this.showUIIndex = 2;
                this._getAddress();
                break;
            case businessConstants.addressType.entity:
                this.showUIIndex = 3;
                break;
            case businessConstants.addressType.duplicate:
                this.showUIIndex = 4;
                this.duplicateAddress = Object.values(this.marker.duplicateAddress);
                break;
            case businessConstants.addressType.event:
                this.showUIIndex = 5;
                break;
            case businessConstants.addressType.google:
            default:
                this.showUIIndex = 1;
                // TODO should use marker.address,but current get loaction api note include wait change after change another api
                // by marcus 7/13
                if (!this.marker.address) {
                    this.marker.address = this.marker.entityName;
                }
                break;
        }
    }
}
